import script from "./FilaHorario.vue?vue&type=script&setup=true&lang=js"
export * from "./FilaHorario.vue?vue&type=script&setup=true&lang=js"

import "./FilaHorario.vue?vue&type=style&index=0&id=394ef0d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394ef0d4"]])

export default __exports__